import { from } from 'rxjs';
import { PromisifyImage } from '#/utils/preloadAssets.js';

export const promiseFactory = (url) => () => {
  return from(PromisifyImage(url));
};
